import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/**
 * Returns a localized and capitalized "Blank" message. Necessary when CSS
 * can't easily do the job (like in the chart SVG)
 */
function blankMessage (value) {
	return _.capitalize(i18n.get('common.blank'))
}

export default blankMessage

blankMessage.__filename__ = 'charts/blank-message.js'
